import {
  ClockCircleOutlined,
  FileTextOutlined,
  LoadingOutlined,
  RightOutlined,
  DownOutlined,
} from "@ant-design/icons";
import {
  Divider,
  Col,
  Row,
  Typography,
  Timeline as AntTimeline,
  Card,
} from "antd";
import dayjs from "dayjs";
import { useState } from "react";

const { Text, Title } = Typography;

interface Props {
  data: any;
  isModalVisible?: boolean;
  handleCancel?: any;
  handleOpen?: any;
  handleSetDocumentUrl?: any;
  handleDownloadDocument?: any;
  downloadingDocumentUrl?: string;
  isDownloadingDocument?: boolean;
}

const MailTimelineContent: React.FC<Props> = ({
  data,
  handleOpen,
  handleDownloadDocument,
  isDownloadingDocument,
  downloadingDocumentUrl,
}) => {
  const [expandedId, setExpandedId] = useState<number | null>(null);

  const toggleExpand = (id: number) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  if (!data || data.length === 0) return null;

  //   const statusColors: Record<string, string> = {
  //     APPROVAL: "#52c41a",
  //     APPROVED: "#52c41a",
  //     REJECTED: "#f5222d",
  //     QUERY: "#faad14",
  //     SUBMITTED: "#1890ff",
  //     OTHER: "#595959",
  //   };

  //   const getStatusColor = (status: string) => {
  //     const key = Object.keys(statusColors).find((k) =>
  //       status?.toUpperCase().includes(k),
  //     );
  //     return statusColors[key || "OTHER"];
  //   };

  return (
    <>
      {/* HEADER */}
      <Row align="middle" justify="space-between" style={{ marginBottom: 16 }}>
        <Col>
          <Title level={4} style={{ margin: 0, color: "#1890ff" }}>
            <ClockCircleOutlined style={{ marginRight: 8, color: "#faad14" }} />
            Mail Timeline
          </Title>
        </Col>
      </Row>

      <div
        style={{
          maxHeight: "70vh",
          overflowY: "auto",
          padding: "24px",
          background: "linear-gradient(135deg, #f5f7fa 60%, #e6f7ff 100%)",
          borderRadius: 12,
        }}
      >
        <AntTimeline>
          {data.map((item: any, index: number) => {
            const isExpanded = expandedId === item.id;

            return (
              <AntTimeline.Item
                key={item.id}
                // color={index === 0 ? "green" : getStatusColor(item.updatedStatus)}
              >
                <Card
                  size="small"
                  bordered={false}
                  style={{
                    borderRadius: 12,
                    background: "#fff",
                    boxShadow: "0 2px 12px rgba(24,144,255,0.08)",
                    // borderLeft: `6px solid ${getStatusColor(item.updatedStatus)}`,
                  }}
                  bodyStyle={{ padding: "14px 18px" }}
                >
                  {/* 🔹 STATUS ROW WITH EXPAND ICON */}
                  <Row
                    align="middle"
                    justify="space-between"
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleExpand(item.id)}
                  >
                    <Col>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        {isExpanded ? <DownOutlined /> : <RightOutlined />}
                        <Text
                          strong
                          style={{
                            fontSize: 15,
                            // color: getStatusColor(item.updatedStatus),
                          }}
                        >
                          {item.updatedStatus}
                        </Text>
                      </div>
                    </Col>

                    <Col>
                      <Text type="secondary" style={{ fontSize: 12 }}>
                        {dayjs(item.updatedAt).format("DD MMM YYYY, hh:mm A")}
                      </Text>
                    </Col>
                  </Row>

                  {expandedId === item.id && (
                    <>
                      <Divider style={{ margin: "12px 0" }} />

                      <Row gutter={[24, 12]}>
                        {item.schemeName && (
                          <Col span={12}>
                            <Text
                              type="secondary"
                              style={{ fontSize: 14, fontWeight: 700 }}
                            >
                              Scheme Name :-
                            </Text>
                            <br />
                            <Text strong>{item.schemeName}</Text>
                          </Col>
                        )}

                        {item.sourceFromEmail && (
                          <Col span={12}>
                            <Text
                              type="secondary"
                              style={{ fontSize: 14, fontWeight: 700 }}
                            >
                              Source Email :-
                            </Text>
                            <br />
                            <Text strong>{item.sourceFromEmail}</Text>
                          </Col>
                        )}

                        {item.mailSubject && (
                          <Col span={24}>
                            <Text
                              type="secondary"
                              style={{ fontSize: 14, fontWeight: 700 }}
                            >
                              Mail Subject :-
                            </Text>
                            <br />
                            <Text strong>{item.mailSubject}</Text>
                          </Col>
                        )}

                        {item.mailBody && (
                          <Col span={24}>
                            <Text
                              type="secondary"
                              style={{ fontSize: 14, fontWeight: 700 }}
                            >
                              Mail Body :-
                            </Text>
                            <div
                              style={{
                                marginTop: 6,
                                padding: 12,
                                background: "#fafafa",
                                borderRadius: 8,
                                whiteSpace: "pre-wrap",
                              }}
                            >
                              {item.mailBody}
                            </div>
                          </Col>
                        )}
                      </Row>
                    </>
                  )}

                  <Divider style={{ margin: "10px 0" }} />

                  {/* 🔹 DETAILS + DOCUMENTS (SINGLE LINE) */}
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                      gap: "36px",
                      fontSize: 13,
                    }}
                  >
                    <div>
                      <Text type="secondary">UPDATED BY:</Text>
                      <br />
                      <Text strong>{item.updatedBy}</Text>
                    </div>

                    {item.policyNumber && (
                      <div>
                        <Text type="secondary">POLICY NO.</Text>
                        <br />
                        <Text strong>{item.policyNumber}</Text>
                      </div>
                    )}

                    {item.intimatedAmount && (
                      <div>
                        <Text type="secondary">INTIMATED AMOUNT</Text>
                        <br />
                        <Text strong style={{ color: "#faad14" }}>
                          ₹{item.intimatedAmount}
                        </Text>
                      </div>
                    )}

                    {item.approvedAmount && (
                      <div>
                        <Text type="secondary">APPROVED AMOUNT</Text>
                        <br />
                        <Text strong style={{ color: "#52c41a" }}>
                          ₹{item.approvedAmount}
                        </Text>
                      </div>
                    )}

                    {item.finalApprovedAmount && (
                      <div>
                        <Text type="secondary">FINAL APPROVED AMOUNT</Text>
                        <br />
                        <Text strong style={{ color: "#1890ff" }}>
                          ₹{item.finalApprovedAmount}
                        </Text>
                      </div>
                    )}

                    {item.documentUrl && (
                      <div style={{ display: "flex", gap: 20 }}>
                        <span
                          style={{
                            color: "rgb(0, 84, 157)",
                            fontWeight: 500,
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            handleOpen(item.visitId, "Mail", item.documentUrl)
                          }
                        >
                          <FileTextOutlined /> VIEW DOCUMENT
                        </span>

                        <span
                          style={{
                            color: "darkcyan",
                            fontWeight: 500,
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            handleDownloadDocument("Mail", item.documentUrl)
                          }
                        >
                          {isDownloadingDocument &&
                          downloadingDocumentUrl === item.documentUrl ? (
                            <LoadingOutlined />
                          ) : (
                            <>
                              <FileTextOutlined /> DOWNLOAD DOCUMENT
                            </>
                          )}
                        </span>
                      </div>
                    )}
                  </div>

                  {/* 🔹 EXPANDED SECTION (OPTIONAL DATA) */}
                  {isExpanded && item.queryRequirements && (
                    <>
                      <Divider style={{ margin: "10px 0" }} />
                      <Text type="secondary">Query</Text>
                      <br />
                      <Text strong>{item.queryRequirements}</Text>
                    </>
                  )}
                </Card>
              </AntTimeline.Item>
            );
          })}
        </AntTimeline>
      </div>
    </>
  );
};

export default MailTimelineContent;
